import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import '@shoelace-style/shoelace/dist/shoelace.js';
import '../../components/product-searchresults';

import { sectionStyles } from './search-styles';
import { styles as sharedStyles } from '../../styles/shared-styles'
import { RootState, store } from '../../store';
import { Unsubscribe } from '@reduxjs/toolkit';
import { ProductSearchQueryArgs, ProductsQuery, ProductStatsQuery } from '../../api/models';
import { Layout, selectLayout, selectProductSearchQueryArgs } from '../../state/pages';
import { selectProductSearchQuery, selectProductStatsQuery } from '../../api/products';
import { isInlist } from '../../state/products';
import '../../components/search-navigation';
import { updateMetadata } from '../../metadata';
import { SHOPS } from '../../constants';

// import { isInlist } from '../../state/products';
// import { selectProductQuery } from '../../api/product';

@customElement('app-search')
export class AppSearch extends LitElement {

  static styles = [
    sharedStyles,
    sectionStyles,
    css`
    :host {
      display: block;
      box-sizing: border-box;
      padding: 0px;
      margin: 0px;
      background-color: transparent;
    } 


    `
  ]

  @property({ attribute: false, state: true, type: Number })
  private layout: Layout = Layout.PHONE;

  @property({ attribute: false, state: true, type: Object })
  private productSearchQueryArgs: ProductSearchQueryArgs = {};

  @property({ attribute: false, state: true, type: Object })
  private productsSearchQuery: ProductsQuery | null = null;

  @property({ attribute: false, state: true, type: Array })
  private favorites: boolean[] = [] as boolean[];

  @property({ attribute: false, state: true, type: Object })
  private productStatsQuery: ProductStatsQuery | null = null;

  render() {
    return html`
      <search-navigation .layout=${this.layout} .productStatsQuery=${this.productStatsQuery} .productsSearchQuery=${this.productsSearchQuery}></search-navigation>
      <product-searchresults 
          .productsSearchResponse=${this.productsSearchQuery}
          .productsFavorites=${this.favorites}
          .layout=${this.layout}
          caption="Zoekresultaten">
      </product-searchresults>

    `;
  }

  scriptTag: HTMLScriptElement | null = null;

  private stateUnsubscribe: Unsubscribe = () => { };

  stateChanged(state: RootState) {
    this.layout = selectLayout(state);
    this.productSearchQueryArgs = selectProductSearchQueryArgs(store.getState());
    this.productsSearchQuery = selectProductSearchQuery(store.getState(), this.productSearchQueryArgs);
    this.productStatsQuery = selectProductStatsQuery(state);
    this.favorites = (this.productsSearchQuery?.data?.results || []).map(result => {
      if (result.shop && result.product_ref) return isInlist(state, result.shop, result.product_ref);
      else return false;
    });
  }

  connectedCallback() {
    super.connectedCallback();
    this.scriptTag = document.querySelector('script[type="application/ld+json"]') as HTMLScriptElement;
    this.stateUnsubscribe = store.subscribe(() => {
      const state = store.getState();
      this.stateChanged(state);
    });
    // update immediately
    const state = store.getState();
    this.stateChanged(state);
  }

  updated(changedProperties: Map<string | number | symbol, unknown>) {
    if (changedProperties.has("productsSearchQuery") && this.productsSearchQuery?.data) {
      // make sharing beautiful
      updateMetadata({
        title: `Search Results - Supermarktprijzen`,
        description: `Vergelijk prijzen van ${Object.keys(SHOPS).length} verschillende supermarkten. Vind de beste promos en winkel slim.`,
        image: `${window.location.origin}/assets/screenshots/search-screen.png`,
        imageAlt: 'Supermarket price comparison search results',
      });
      this.renderStructuredData();
    }
  }  

  disconnectedCallback() {
    this.stateUnsubscribe();
  }


  renderStructuredData() {
    if (!this.productsSearchQuery?.data?.results) return;

    const structuredData = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      "itemListElement": this.productsSearchQuery.data.results.map((product, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "item": {
          "type": "Product",
          "offers": [{
            "type": "Offer",
            "name": product.product_name,
            "availability": "https://schema.org/InStock",
            "price": product?.price,
            "priceCurrency": "EUR",
            "priceValidUntil": new Date().toISOString(),
            "url": window.location.href,
          }],
          "brand":
            { "name": product.brand },
          "name": product.product_name,
          "description": `Vergelijk prijzen voor ${product.product_name}. Vind de beste deals bij ${product.shop} en andere supermarkten op Supermarktprijzen.be`,
          "category": product.categories?.join("") || "",
          "url": `${window.location.origin}productid/${product.productId}/Gearomatiseerd%20water%20|%20Bruisend%20|%20Limoen`,
          "image": {
            "type": "ImageObject",
            "url": `${window.location.origin}/api/product/${product.productId}/img/200`,
            "image": `${window.location.origin}/api/product/${product.productId}/img/200`,
            "name": product.product_name,
            "width": "200",
            "height": "200"
          }

        }
      }))
    };
    if (this.scriptTag) {
      this.scriptTag.innerText = JSON.stringify(structuredData);
    }
  }
}
